const types = require('../../constants/actionTypes');


const selected = ({ id }) => ({
    type: types.GLOBAL_STOCK_SELECTED,
    payload: { id },
});


module.exports = selected;
